import { createReducer } from '@reduxjs/toolkit';

import {
    ERROR_STATE,
    LOADING_STATE,
    SUCCESS_STATE,
} from '@perpay-web/data-module/constants';
import { createDataModule } from '@perpay-web/data-module/createDataModule';
import { getDataModuleInitialState } from '@perpay-web/data-module/getDataModuleInitialState';
import {
    fetchFeatureSwitchError,
    fetchFeatureSwitchRequest,
    fetchFeatureSwitchReset,
    fetchFeatureSwitchSuccess,
} from '@perpay-web/fintech/actions/shared/featureSwitches';

// Custom reducer that merges feature switch results instead of replacing them
const createFeatureSwitchesReducer = (initialValue) =>
    createReducer(getDataModuleInitialState(initialValue), (builder) => {
        builder.addCase(fetchFeatureSwitchRequest().type, (state) => ({
            ...state,
            requestState: LOADING_STATE,
            errors: {},
        }));
        builder.addCase(fetchFeatureSwitchError().type, (state, action) => ({
            ...state,
            requestState: ERROR_STATE,
            errors: action.payload,
        }));
        builder.addCase(fetchFeatureSwitchSuccess().type, (state, action) => ({
            ...state,
            requestState: SUCCESS_STATE,
            value: { ...state.value, ...action.payload }, // Merge instead of replace
        }));
        builder.addCase(fetchFeatureSwitchReset().type, () =>
            getDataModuleInitialState(initialValue),
        );
    });

const FetchFeatureSwitchesDataModule = createDataModule({
    dataRequest: fetchFeatureSwitchRequest,
    dataSuccess: fetchFeatureSwitchSuccess,
    dataError: fetchFeatureSwitchError,
    dataReset: fetchFeatureSwitchReset,
});

const getRoot = (state) => state.dataModules.fetchFeatureSwitches;
const initialValue = {};

export const fetchFeatureSwitchesDataModule = {
    ...FetchFeatureSwitchesDataModule({
        getRoot,
        initialValue,
    }),
    reducer: createFeatureSwitchesReducer(initialValue),
};

const getFeatureSwitches = (state) =>
    fetchFeatureSwitchesDataModule.getData(state);

const getFeatureSwitchByName = (state, featureSwitchName) =>
    getFeatureSwitches(state)[featureSwitchName] || {};

/**
 * @returns {boolean}
 */
export const getFeatureSwitchEnabled = (state, featureSwitchName) => {
    const featureSwitch = getFeatureSwitchByName(state, featureSwitchName);
    return featureSwitch.isEnabled || false;
};
